import { Pipe, PipeTransform } from '@angular/core';
import {
  ChatMessageTypeEnum,
  ChatTypeEnum,
  XpressUserRoleEnum,
} from 'app/models';

@Pipe({
  name: 'getCurrentChatType',
})
export class GetCurrentChatTypePipe implements PipeTransform {
  transform(xpressUserRoleId: any, chatTypeId: ChatTypeEnum): string {
    if (
      xpressUserRoleId === XpressUserRoleEnum.Merchant &&
      chatTypeId === ChatTypeEnum.MerchantSupport
    ) {
      return 'SUPPORT';
    } else if (
      xpressUserRoleId === XpressUserRoleEnum.Admin &&
      XpressUserRoleEnum.Merchant &&
      chatTypeId === ChatTypeEnum.MerchantSupport
    ) {
      return 'MERCHANT';
    }
    return '';
  }
}
